import { type StateStorage } from "zustand/middleware";
import { Preferences } from "@/lib/capacitor/Preferences";

export const CapacitorStorage: StateStorage = {
	getItem: (key) => Preferences.get(key).then(({ value }) => value),
	setItem: (key, value) => Preferences.set({ key, value }),
	removeItem: (key) => Preferences.remove(key),
};
